<template>
  <div class="mobile-index">
    <div class="main">
      <img class="czur-logo" src="../assets/images/czur_logo.png" alt="">
      <div class="czur-cloud">{{$t('index.loginText')}}</div>
      <div class="text text-bold">{{$t('index.mobileTip')}}<br>{{$t('index.youCan')}}</div>
      <div class="text">{{$t('index.mobileTextOne')}}</div>
      <div class="text pad-le-ri">{{$t('index.mobileTextTwo')}}</div>
      <a class="download-btn" v-if="downloadCn" href="https://www.czur.com/cn/app/czur" target="_blank">{{$t('index.downloadApp')}}</a>
      <a class="download-btn" v-if="!downloadCn" href="https://www.czur.com/en/app/czur" target="_blank">{{$t('index.downloadApp')}}</a>
    </div>
    <div class="site-url">www.czur.cc</div>
  </div>
</template>
<script>
import * as config from 'common/script/config'
export default {
  name: 'mobileindex',
  data () {
    return {
      downloadCn: false
    }
  },
  created: function () {
    if (config.CHANNEL === 'CN') {
      this.downloadCn = true
    } else if (config.CHANNEL === 'US') {
      this.downloadCn = false
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
.mobile-index
  width 100%
  height 100%
  background-image url(../assets/images/mobile_bg.jpg)
  background-size cover
  background-position center
  position relative
  .main
    width 100%
    height 280px
    text-align center
    position absolute
    top 50%
    margin-top -140px
    .czur-logo
      width 40px
    .czur-cloud
      font-size 26px
      color #fff
      margin 10px 0 20px
    .text
      color #9da6c4
      font-size 16px
      line-height 24px
      &.text-bold
        font-weight bold
        width 90%
        margin-left 5%
      &.pad-le-ri
        padding 0 5px
    .download-btn
      background-color #9da6c4
      width 114px
      height 30px
      line-height 30px
      color #000
      font-size 14px
      border-radius 30px
      position absolute
      bottom 0
      left 50%
      margin-left -57px
  .site-url
    position absolute
    bottom 30px
    font-size 14px
    color #9da6c4
    width 100%
    text-align center
@media (max-width: 767px)
  body,html
    height 100% !important
    min-width unset !important
</style>



// WEBPACK FOOTER //
// src/components/MobileIndex.vue